import React from "react";
import RecoveryExpired from "./RecoveryExpired";

const RecoveryExpiredContainer = () => <RecoveryExpired />;

export default RecoveryExpiredContainer;
